var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgWazuhLog(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 162,
    height: 33,
    viewBox: "0 0 2214 455",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 1096.56 263)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -853.6 5.59)",
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "102.79,64.95 29.21,-174.21 -28.88,-174.21 -102.48,64.95 -175.41,-174.37 -242.23,-174.37 -135.72,174.37 -81.5,174.37 0.17,-78.03 81.5,174.37 135.72,174.37 242.23,-174.21 175.74,-174.21 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -4.02 5.67)",
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "-134.41,-113.94 45.34,-113.94 -152.5,163.62 -152.5,174.29 142.83,174.29 142.83,113.94 -45.01,113.94 152.5,-163.31 152.5,-174.29 -134.41,-174.29 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -405.16 5.95)",
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-938.4, -545.95)",
    d: "M 1052.639 408.128 c -29.888 -31.188 -70.664 -47.599 -118.641 -47.599 c -101.53 0 -178.083 79.72 -178.083 185.428 c 0 105.697 76.553 185.405 178.083 185.405 c 47.865 0 88.642 -16.31 118.641 -47.287 v 39.977 h 68.243 V 367.863 h -68.243 V 408.128 z M 940.953 667.143 c -67.02 0 -115.686 -50.965 -115.686 -121.185 c 0 -69.998 48.665 -120.807 115.686 -120.807 c 66.82 0 115.33 50.81 115.33 120.807 C 1056.283 616.178 1007.774 667.143 940.953 667.143 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 371.69 9.61)",
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1715.24, -549.61)",
    d: "M 1809.883 568.668 c 0 62.576 -34.443 98.475 -94.464 98.475 c -60.243 0 -94.797 -35.899 -94.797 -98.475 V 367.863 h -68.265 v 206.294 c 0 116.03 87.842 157.206 163.062 157.206 c 75.064 0 162.706 -41.176 162.706 -157.206 V 367.863 h -68.242 V 568.668 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 775.51 -41.04)",
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-2119.06, -498.96)",
    d: "M 2272.846 488.87 c -1.933 -14.211 -5.6 -28.733 -10.977 -43.577 c -5.378 -14.844 -13.177 -28.566 -23.399 -41.154 c -10.222 -12.577 -23.51 -22.744 -39.843 -30.499 c -16.355 -7.744 -36.599 -11.611 -60.687 -11.611 c -31.421 0 -58.198 6.778 -80.353 20.333 c -13.567 8.293 -25.174 18.601 -34.865 30.88 V 277.955 h -60.354 v 442.009 h 68.42 V 538.569 c 0 -20.655 2.311 -38.188 6.933 -52.609 c 4.644 -14.411 10.978 -26.033 19.044 -34.855 c 8.066 -8.822 17.488 -15.222 28.243 -19.199 c 10.755 -3.989 22.155 -5.978 34.221 -5.978 c 18.489 0 33.51 3.766 45.021 11.3 s 20.444 17.422 26.777 29.688 c 6.355 12.266 10.666 25.555 12.911 39.866 c 2.267 14.311 3.4 28.232 3.4 41.788 v 171.395 h 68.42 V 526.303 C 2275.758 515.547 2274.78 503.07 2272.846 488.87 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 1062.43 131.88)",
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,122,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    r: 55.013
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWazuhLog);
export default __webpack_public_path__ + "static/media/wazuh-log.c6ec87f7b4e9fb44ecf335e97d788905.svg";
export { ForwardRef as ReactComponent };